const TokenKey = "Authorization";
const SessionId = "sessionId";
const Language = "language";
export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}
export function getSessionId() {
  return localStorage.getItem(SessionId);
}

export function setSessionId(sessionId) {
  return localStorage.setItem(SessionId, sessionId);
}

export function removeSessionId() {
  return localStorage.removeItem(SessionId);
}
export function setLanguage(language) {
  return localStorage.setItem(Language, language);
}
export function getLanguage() {
  return localStorage.getItem(Language);
}
export function removeLanguage() {
  return localStorage.remove(Language);
}
